import { FC } from "react";
import { Text } from "@mantine/core";

interface EmptyStateProps {
  message: string;
}

export const EmptyState: FC<EmptyStateProps> = ({ message }) => {
  return (
    <Text c="dimmed" ta="center" py="xl" size="sm">
      {message}
    </Text>
  );
};
